<template>
    <v-modal ref="modal" @opened="modalOpened" :disabled="disabled" :state="keepModalOpen" customButtonClass="c-dialog__button_send-reminders">
        <slot slot="title">{{ $t('preorder.close_preorder') }}</slot>
        <slot slot="buttonContent">
            <div class="c-button c-button--fullwidth c-button--alpha">{{ $t('preorder.close_preorder') }}</div>
        </slot>
        <div class="c-targets o-gutter">
            <div>{{ $t('preorder.close_confirmation')}}<br/><br/></div>
            <div>
                <v-add-user @userAdded="addNewUser" 
                    :customerKey="this.PreOrder.CustomerKey"
                    :roleOptions="[
                        { value: 'Klant', content: $t('users.roles.administrator')},
                        { value: 'MarketingKlant', content: 'Marketing'},
                        { value: 'PersoneelKlant', content: $t('users.roles.personnel')}
                    ]">
                </v-add-user>
            </div>
            <div class="c-table-wrapper">
                <table-component class="o-page-row" table-class="c-table c-table--small" :data="CustomerUsersOptions" :show-caption="false" :show-filter="false">

                    <table-column key="FirstName" :label="$t('users.first_name')" :sortable="false">
                        <template slot-scope="row">
                            {{row["FirstName"]}}
                        </template>
                    </table-column>
                    <table-column key="LastName" :label="$t('users.last_name')" :sortable="false">
                        <template slot-scope="row">
                            {{row["LastName"]}}
                        </template>
                    </table-column>
                    <table-column key="Email" :label="$t('users.email')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Email"]}}
                        </template>
                    </table-column>
                    <table-column key="SendConfirmation" :label="$t('preorder.send_confirmation')" :sortable="false">
                        <template slot-scope="row">
                            <v-switch @input="updateUser(row, $event)" name="send_confirmation" :value="false">
                            </v-switch>
                        </template>
                    </table-column>
                </table-component>
            </div>
            <div>
                <button :disabled="disabled" type="button" class="c-button c-button--alpha" @click="closePreOrder">{{ $t('preorder.close_preorder') }}</button>
            </div>
        </div>
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VSwitch from '@/components/form/Switch'
    import VAddUser from '@/components/form/userSelect/AddUser'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VSwitch,
            VAddUser
        },
        props: {
            disabled: {type: Boolean, default: false}
        },
        data() {
            return {
                keepModalOpen: false
            }
        },
        computed: {
            ...mapGetters({
                PreOrder: 'PreOrder',
                CustomerUsersOptions: 'CustomerUsersOptions'
            })
        },
        methods: {
            modalOpened(){
                //load data in CustomersUsersOptions
                this.$store.dispatch('getCustomerUsersOptions', this.PreOrder.CustomerKey).then(() => {
                    this.CustomerUsersOptions.forEach(user => {
                        user.IsSelected = false
                    });
                });
            },
            addNewUser(newUser) {
                newUser.IsSelected = true;
                this.CustomerUsersOptions.push(newUser); //add new user to options
            },
            updateUser(row, isSelected){
                row.IsSelected = isSelected;
            },
            closePreOrder(){
                this.disabled = true;
                let selectedUsers =  this.CustomerUsersOptions.filter(user => { return user.IsSelected });
                let emails = selectedUsers.map(a => a.Email);

                this.$store.dispatch('closePreOrderById', {
                    preOrderId: this.PreOrder.Id,
                    body: {
                        Id: this.PreOrder.Id,
                        Users: emails
                    }
                }).then((response) => {
                    if(response.status > 300){
                        this.$emit('validateForm', response);
                        this.$refs.modal.closeDialog();
                    } else {
                        this.$notify({
                            group: 'global',
                            title: 'Pre-order '+this.PreOrder.Brand+' - '+this.PreOrder.Collection+' is succesvol afgesloten.',
                            type: 'success',
                            duration: 2000
                        });

                        // Close dialog
                        this.$refs.modal.closeDialog();

                        // Navigate to salesman overview
                        this.$router.push({ name: 'SalesmanPreOrdersOverview' });                        
                    }                    
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>



// WEBPACK FOOTER //
// src/components/modal/salesman/ClosePreOrder.vue